import { LogObject, Logger } from '../types'

const logUrl = getHostUrl()

function getHostUrl() {
  let biUrl = 'https://frog.wix.com/'
  const hostName =
    ((window as any).location && (window as any).location.hostname) || ''
  if (hostName.indexOf('.editorx.com') > -1) {
    biUrl = 'https://frog.editorx.com/'
  }
  return biUrl
}

export const logger: Logger = {
  acceptButtonClicked,
  openedPanel,
  saveButtonClicked,
  declineAllClicked,
  dismissClicked,
  cookieLinkClicked,
  cookieLinkClickedModal,
  toggleClicked,
  closePanelClicked,
  rendered,
}

function log(eventData: LogObject | any) {
  let logURI = `${logUrl}gdpr?src=5`
  eventData.url = location.href
  Object.keys(eventData).forEach((key: string) => {
    logURI += `&${encodeURIComponent(key)}=${encodeURIComponent(
      eventData[key],
    )}`
  })
  return sendTheBI(logURI)
}

function sendTheBI(logURI: string) {
  if (isIOS()) {
    return sendImage(logURI)
  } else {
    return sendBeacon(logURI) || sendImage(logURI)
  }
}

function isIOS() {
  const userAgent = navigator.userAgent || ''
  return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)
}

function sendBeacon(url: string) {
  let sent = false
  try {
    if (navigator && navigator.sendBeacon) {
      sent = navigator.sendBeacon(url)
    }
  } catch (e) {
    // Linty linter linted something
  }
  return sent
}

function sendImage(url: string) {
  const img = new Image()
  img.src = url
  return true
}

function rendered() {
  log({
    evid: 814,
    action: 'render',
  })
}

function acceptButtonClicked(): void {
  log({
    evid: 814,
    action: 'accept',
  })
}

function cookieLinkClicked(): void {
  log({
    evid: 814,
    action: 'read_policy',
  })
}

function openedPanel(): void {
  log({
    evid: 814,
    action: 'settings',
  })
}

function declineAllClicked(): void {
  log({
    evid: 814,
    action: 'decline_all',
  })
}

function dismissClicked(): void {
  log({
    evid: 814,
    action: 'dismiss',
  })
}

function saveButtonClicked(toggle: boolean): void {
  log({
    evid: 815,
    toggle,
    action: 'save',
  })
}

function toggleClicked(toggle: boolean) {
  log({
    evid: 815,
    toggle,
    action: 'toggle',
  })
}

function cookieLinkClickedModal(): void {
  log({
    evid: 815,
    action: 'read_policy',
  })
}

function closePanelClicked() {
  log({
    evid: 815,
    action: 'dismiss',
  })
}
